var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXiaofangdengju(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 0.5,
    width: 13,
    height: 15,
    fill: "#FF0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 0.5,
    width: 13,
    height: 15,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 8.5335C12.25 10.448 10.683 12 8.75 12C6.817 12 5.25 10.448 5.25 8.5335C5.25 6.6185 6.596 5.8665 7.135 4C9.2885 4.9335 9.2885 7.7335 9.2885 7.7335C9.2885 7.7335 9.827 6.1335 11.4425 5.7335C11.577 7.2 12.25 7.716 12.25 8.5335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXiaofangdengju);
export default __webpack_public_path__ + "static/media/xiaofangdengju.9f498cc005f4401394481bb25741c857.svg";
export { ForwardRef as ReactComponent };